import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container"]

  connect() {
    this.handleSubmitStart = this.handleSubmitStart.bind(this)
    this.handleSubmitEnd = this.handleSubmitEnd.bind(this)

    document.addEventListener("turbo:submit-start", this.handleSubmitStart)
    document.addEventListener("turbo:submit-end", this.handleSubmitEnd)
    // With ActiveStorage direct uploads the files go straight to storage
    // before the form submits, so show the overlay for that phase too and
    // hide it if an upload errors out (the form never submits in that case).
    document.addEventListener("direct-uploads:start", this.handleSubmitStart)
    document.addEventListener("direct-upload:error", this.handleSubmitEnd)
  }

  disconnect() {
    document.removeEventListener("turbo:submit-start", this.handleSubmitStart)
    document.removeEventListener("turbo:submit-end", this.handleSubmitEnd)
    document.removeEventListener("direct-uploads:start", this.handleSubmitStart)
    document.removeEventListener("direct-upload:error", this.handleSubmitEnd)
  }

  handleSubmitStart(event) {
    if (event.target.querySelector('input[type="file"]')) {
      this.containerTarget.classList.remove("hidden")
    }
  }

  handleSubmitEnd() {
    this.containerTarget.classList.add("hidden")
  }
} 